var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightArrowBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 5.497,
  height: 9.614,
  viewBox: "0 0 5.497 9.614"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-arrow-down",
  "data-name": "Icon ionic-ios-arrow-down",
  d: "M4.809,3.84,8.444.2a.684.684,0,0,1,.97,0,.693.693,0,0,1,0,.973L5.3,5.3a.686.686,0,0,1-.947.02L.2,1.178A.687.687,0,0,1,1.171.2Z",
  transform: "translate(0 9.614) rotate(-90)",
  fill: "currentColor"
})));
export { SvgRightArrowBlue as ReactComponent };
export default __webpack_public_path__ + "static/media/right-arrow-blue.379901d516c114704815477bfe7efc78.svg";